import {
  UPDATE_SERVICE,
  RESET_SERVICE
} from "./actionTypes"

export const update_service = service => {
  return {
    type: UPDATE_SERVICE,
    payload: service,
  }
}

export const reset_service = service => {
  return {
    type: RESET_SERVICE,
  }
}
